export interface LogoProps {
  readonly size?: number;
  readonly className?: string;
}

export function Logo({ size = 80, className = '' }: LogoProps) {
  return (
    <img
      src="/logo.png"
      width={size}
      height={size}
      alt="Gonka"
      className={`select-none ${className}`.trim()}
      draggable={false}
    />
  );
}
